import { createFileRoute } from "@tanstack/react-router";

import { AgentLocalSettings } from "@/features/agent/AgentLocalSettings";

export const Route = createFileRoute("/agent/local-settings")({
  component: AgentLocalSettings,
});
